<template>
    <CModal
      :title="title"
      :color="color"
      size="lg"
      :show.sync="showModal"
    >   
		<CForm id="sales_form" method="POST" enctype="multipart/form-data">
            <CRow>
            	<CCol md="12">
                	<a style="float: right; font-size: 12px;" target="_blank" href="https://api.kpibonus.com/sales.xlsx">Descargar Plantilla</a>
					<CInput
					label="Archivo a Importar:"
					name="sales_file"
					id="sales_file"
					type="file"
					:lazy="false"
					:value.sync="$v.form.sales_file.$model"
					placeholder=""
					autocomplete="given-name"
					invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres."
					required
					/>
              	</CCol>
            </CRow>
            <br/>
            <CRow>
              	<CCol md="12">
					<label>Proveedor:</label>
					<CSelect
					name="provider_id"
					:value.sync="providerSelected" 
					:options="providersOptions"
					/>
				</CCol>
            </CRow>
        </CForm>

		<template v-if="hasErrorsImport == 1">
			<CRow>
				<CCol md="12">
				<CAlert color="danger" variant="solid">
					<strong>Se encontraron los siguientes errores al importar:</strong>
				</CAlert>
					<CDataTable
					:items="importIssues"
					:fields="['N°', 'Fila', 'Columna', 'Error']"
					:items-per-page="10"
					hover
					bordered
					small
					responsive
					class="mt-3"
					:no-sorting="true"
					:sorter="false"
					>
					<template #N°="{ index }">
						<td style="font-size: 10px;">
						{{ index + 1 }}
						</td>                
					</template>
					<template #Fila="{ item }">
						<td style="font-size: 10px;">
						{{ item.row || '-' }}
						</td>
						
					</template>
					<template #Columna="{ item }">
						<td style="font-size: 10px;">
						{{ item.column || '-' }}
						</td>                
					</template>
					<template #Error="{ item }">
						<td style="font-size: 10px;">
						{{ item.message }}
						</td>                
					</template>
					</CDataTable>
				</CCol>
			</CRow>
		</template>
		<template v-else-if="hasErrorsImport == 0 && submitted">
			<CRow>
				<CCol md="12">
				<CAlert color="success" variant="solid">
					<strong>¡El archivo se importó correctamente sin errores!</strong>
				</CAlert>
				</CCol>
			</CRow>
		</template>

        <template #footer>
        	<CButton @click="closeModal" color="secondary">Cancelar</CButton>
          	<CButton @click="importSales" :color="color">Importar</CButton>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required } from "vuelidate/lib/validators"
import ws from '../../services/sales';
import providers_ws from '../../services/providers';
import store from '../../store'

export default {
	name: 'ImportSalesModal',
	props: {		
	},
	data () {
		return {
		showModal: false,
		title: "Importar Ventas",
		color: "success",
		isEdit: false,
		form: this.getEmptyForm(),
		submitted: false,
		importIssues: [],
		hasErrorsImport: 0,
		providers: [],
		providersOptions: [],
		providerSelected: "",
		}
	},
	mounted: async function() {
		let response = await providers_ws.get();

		if(response.type == "success"){
		this.providers = response.data;

		this.providerSelected = this.providers.length > 0 ? this.providers[0].id : "";

		this.providersOptions = await this.$parseSelectOptionsOrdered(this.providers, "id", "name");
		}
	},
	methods: {
		importModal (challenge_id = 0) {
			this.showModal = true;
			this.color = "success";
			this.title = 'Importar Ventas';
			this.isEdit = false;
			this.submitted = false;

			this.form = {
				id: 0,
				challenge_id: challenge_id,
				sales_file: ''
			}
		},
		async importSales () {
			this.loading();
			this.$v.$touch();

			if (this.isValid) {
				this.submitted = true;

				const form = document.getElementById("sales_form");
				let formData = new FormData(form);

				formData.append("challenge_id", this.form.challenge_id);

				let response = await ws.import(formData);

				if(response.type == "success"){
				this.$emit("import", response.data);
				this.closeModal();
				}

				this.showToast(response.type, response.message);

				this.loaded();
			}
			else{
				this.loaded();
				this.showToast("error", "Debes ingresar un archivo XLSX o CSV para poder continuar.");
			}
		},
		closeModal () {
			this.showModal = false;

			this.form = this.getEmptyForm()
			this.importIssues = [];
			this.hasErrorsImport = 0;
			this.submitted = false
			this.$v.$reset()
		},
		getEmptyForm () {
			return {
				id: 0,
				challenge_id: 0,
				sales_file: '',
			}
		},
		checkIfValid (fieldName) {
			const field = this.$v.form[fieldName]
			if (!field.$dirty) {
				return null
			}
			
			return !(field.$invalid || field.$model === '')
		},
		showToast(type, message){
			store.commit('toast', {color: type, message: message});
		},
		loading(){
			store.commit('loading');
		},
		loaded(){
			store.commit('loaded');
		}
	},
	computed: {
		formString () { return JSON.stringify(this.form, null, 4) },
		isValid () { return !this.$v.form.$invalid },
		isDirty () { return this.$v.form.$anyDirty },
  	},
	mixins: [validationMixin],
	validations: {
		form: {
			sales_file: {
				required
			}
		}
	},
}
</script>